import React from 'react';
import { Frame, Image, Coffee, Shirt, Smartphone, BookOpen, Home, Key, Calendar, Layout, ArrowRight, Upload } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { customCategories } from '../data/mock';

const iconMap = {
  Frame: Frame,
  Image: Image,
  Coffee: Coffee,
  Shirt: Shirt,
  Smartphone: Smartphone,
  BookOpen: BookOpen,
  Home: Home,
  Key: Key,
  Calendar: Calendar,
  Layout: Layout,
};

const CategorySection = () => {
  return (
    <section id="categories" className="relative py-20 lg:py-28 bg-gradient-to-b from-[#1e1919] to-[#252020]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#00d4aa]/10 backdrop-blur-sm border border-[#00d4aa]/30 rounded-full px-4 py-2 mb-6">
            <Layout className="w-4 h-4 text-[#00d4aa]" />
            <span className="text-[#00d4aa] font-medium text-sm">Browse Categories</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Customize <span className="text-[#ffd700]">Anything</span>
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Choose from our wide range of customizable products. Perfect for gifts, memories, and personal expressions.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-6">
          {customCategories.map((category) => {
            const IconComponent = iconMap[category.icon] || Layout;
            return (
              <Card
                key={category.id}
                className="group cursor-pointer bg-gradient-to-br from-white/10 to-white/5 border-white/10 hover:border-[#ffd700]/50 transition-all duration-500 hover:shadow-2xl hover:shadow-[#ffd700]/10 hover:-translate-y-2"
              >
                <CardContent className="p-6 text-center">
                  {/* Icon */}
                  <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-[#ffd700]/20 to-[#ff6b6b]/20 flex items-center justify-center transition-all duration-300 group-hover:bg-[#ffd700]/30 group-hover:scale-110">
                    <IconComponent className="w-8 h-8 text-[#ffd700] transition-transform duration-300 group-hover:scale-110" />
                  </div>
                  
                  {/* Name */}
                  <h3 className="text-white font-semibold mb-1 group-hover:text-[#ffd700] transition-colors">
                    {category.name}
                  </h3>
                  
                  {/* Count */}
                  <p className="text-white/40 text-sm">{category.count} products</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <Button
            size="lg"
            className="bg-gradient-to-r from-[#ffd700] to-[#ffb347] hover:from-[#ffcc00] hover:to-[#ffa500] text-[#1e1919] font-bold px-8"
          >
            Explore All Categories
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
